import CryptoJS from "crypto-js";
import { SECRET_KEY } from "./constant";
// Encrypt data before saving
export const encryptData = (data) => {
    try {
        const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
        return ciphertext;
    } catch (error) {
        console.error("Encryption error:", error);
        return null;
    }
};

// Decrypt data when reading
export const decryptData = (ciphertext) => {
    if (!ciphertext) return null; // early return for empty values

    try {
        const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
        const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

        if (!decryptedText) return null; // invalid decryption

        return JSON.parse(decryptedText);
    } catch (error) {
        console.log("Decryption error:", error, "ciphertext:", ciphertext);
        return null;
    }
};
